import { render, staticRenderFns } from "./ProfileType.vue?vue&type=template&id=33c5cd2c&scoped=true"
import script from "./ProfileType.vue?vue&type=script&lang=js"
export * from "./ProfileType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5cd2c",
  null
  
)

export default component.exports